import { useState, useEffect } from "react";
import { getEmployeeAirportsAPI } from "../services/employee";

function UseEmpsLocation() {
  const [data, setData] = useState([]);
  useEffect(() => {
    const getData = async () => {
      const result = await getEmployeeAirportsAPI();
      if (!result) return;

      const newData = result.result.map((d, i) => {
        return { value: d.location_id, label: d.location_code };
      });

      setData(newData);
    };
    getData();
  }, []);

  return data;
}

export default UseEmpsLocation;
